import('./bootstrap');

// Dev only: Design mode's host, when a stack-control embedded-agent pod wrote one into src/
// (untracked, in .git/info/exclude). A missing file leaves the context empty, never an error,
// and production builds drop this branch.
if (process.env.NODE_ENV === 'development') {
  const designHost = require.context('./', false, /^\.\/sc-design-host\.js$/, 'lazy');
  designHost.keys().forEach(key => designHost(key));
}

if (module.hot) {
  module.hot.accept();
}
